export default {
  rfRubixFlow: '/rubix-flow',
  rfStreamsRoot: '/rubix-flow',
  rfStreams: '/rubix-flow/streams',
  rfProducers: '/rubix-flow/streams/:streamId/producers',
  rfConsumers: '/rubix-flow/streams/:streamId/consumers',
  rfWriterClones: '/rubix-flow/streams/:streamId/producers/:producerId/writer-clones',
  rfCommandGroups: '/rubix-flow/streams/:streamId/command-groups',

  rfFlowNetworkRoot: '/rfn',
  rfFlowNetwork: '/rfn/networks',
  rfFlowNetworkStreams: '/rfn/networks/:flowNetworkId/streams',
  rfFlowNetworkProducer: '/rfn/networks/:flowNetworkId/streams/:streamId/producers',
  rfFlowNetworkWriterClone: '/rfn/networks/:flowNetworkId/streams/:streamId/producers/:producerId/writer-clones',

  rfFlowNetworkCloneRoot: '/rfn-clone',
  rfFlowNetworkClone: '/rfn-clone/networks',
  rfFlowNetworkStreamsClone: '/rfn-clone/networks/:flowNetworkId/streams',
  rfFlowNetworkCloneConsumers: '/rfn-clone/networks/:flowNetworkId/streams/:streamId/consumers',
  rfWriters: '/rfn-clone/networks/:flowNetworkId/streams/:streamId/consumers/:consumerId/writers',

  rfNetworkDevicePoint: '/rubix-flow-ndp',
  rfNetworks: '/rubix-flow-ndp/networks',
  rfDevices: '/rubix-flow-ndp/networks/:networkId/devices',
  rfPoints: '/rubix-flow-ndp/networks/:networkId/devices/:deviceId/points',
  rfAllNetworkDevices: '/rubix-flow-all-network-devices',
  rfAllPoints: '/rubix-flow-all-points',

  rfFrameworkUpgrade: '/plugins-distro',
  rfSchedules: '/rf-schedules',
  syncLogs: '/sync-logs',
};
